import { toast } from 'sonner';

export function useCopy() {
  function copy(value: string | undefined | null) {
    toast.promise(
      async () => {
        if (value === undefined || value === null) throw new Error('Copy value is empty.');
        await navigator.clipboard.writeText(value);
      },
      { success: 'Copied to clipboard!', error: 'Failed to copy.' },
    );
  }

  return { copy };
}
